export default __webpack_public_path__ + "static/easylife365_identity_logo-0fec4e25091a5bebd36264d285231bf7.svg";